<style scoped="scoped" lang="scss"></style>

<template>
  <div style="display: inline;">
    <!-- table表格 -->
    <yi_curd_table v-bind="$attrs" :name="$options.name" ref="yt" getUrl="/web/template/point/unit/page" getKey="rows"
      :columns="columns">
      <!-- 搜索框插槽 -->
      <template #conditions>
        <el-form size="mini" :inline="true" :model="yt.conditions" class="demo-form-inline">
          <el-form-item :label="$t('shujumoban')">
            <el-select filterable :clearable="true" v-model="yt.conditions.templateId">
              <el-option v-for="(item, index) in templateList" :key="index" :label="item.name" :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('模板点编码')">
            <yi_cross_select :max="1" :component="'admin_data_equipment_template_point'"
              :ids.sync="yt.conditions.pointId">
            </yi_cross_select>
          </el-form-item>
          <el-form-item :label="$t('beizhu')">
            <el-input v-model="yt.conditions.remark"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button @click="yt.get(1)" type="primary" plain="plain">
              {{ $t('sousuo') }}
            </el-button>
            <el-button @click="yt.clear({ orderBy: 'createTime desc' })">{{ $t('chongzhi') }}
            </el-button>
            <yi_curd_expand_button></yi_curd_expand_button>
          </el-form-item>
        </el-form>
      </template>
      <!-- 左侧按钮插槽 -->
      <template #buttonsL>
        <el-button size="mini" @click="yt.showEditDialog('xinzeng', null, 'w1')" type="primary">
          {{ $t('xinzeng') }}
        </el-button>
        <el-button style="margin-left: 10px;" size="mini" @click="importExcelShow = !importExcelShow" plain>
          {{ $t('daoru') }}
        </el-button>
      </template>
      <!-- 右侧按钮插槽 -->
      <template #buttonsR>
        <!-- <el-button size="mini" icon="yicon yicon-export" :title="$t('daochu')"  @click="yt.exportExcel()"></el-button>
            </el-button> -->
        <el-button size="mini" icon="yicon yicon-config_column" :title="$t('peizhilie')"
          @click="yt.showColumnsDialog()"></el-button>

      </template>
      <!-- 操作插槽 -->
      <template #caozuo="scope">
        <el-row :gutter="10">
          <el-col :span="0.1">
            <el-button type="text" @click="yt.showEditDialog('bianji', scope.row)">{{ $t('bianji') }}
            </el-button>
          </el-col>
          <el-col :span="0.1">
            <el-button type="text" 	@click="yt.remove(scope.row,'/web/template/point/unit/delete')">{{ $t('shanchu') }}
            </el-button>
          </el-col>
        </el-row>
      </template>
    </yi_curd_table>

    <!-- 新增/编辑弹框 -->
    <el-dialog :show-close="true" :title="$t(yt.editObj.action)" :visible.sync="yt.isShowEditDialog"
      :width="yt.dialogWidth" :close-on-click-modal="false" append-to-body="append-to-body">
      <!-- 新增表单 -->
      <template v-if="yt.editObj.action == 'xinzeng'">
        <el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth">
          <el-form-item :label="$t('mubandianbianma')" required>
            <yi_cross_select :max="1" :component="'admin_data_equipment_template_point'" :ids.sync="yt.editObj.pointId">
            </yi_cross_select>
          </el-form-item>
          <el-form-item :label="$t('danwei')" required>
            <el-input v-model="yt.editObj.unit"></el-input>
          </el-form-item>
          <el-form-item :label="$t('jisuangongshi')" required>
            <el-input v-model="yt.editObj.formula"></el-input>
          </el-form-item>
          <el-form-item :label="$t('zhuanghuanbiaoshi')" required>
            <yi_dictionary_select :max="1" :type="'ADMIN_UNIT_CONVERSION_TYPE'" :ids.sync="yt.editObj.tag">
            </yi_dictionary_select>
          </el-form-item>
          <el-form-item :label="$t('beizhu')">
            <el-input v-model="yt.editObj.remark"></el-input>
          </el-form-item>

        </el-form>
        <template slot="footer" class="dialog-footer">
          <el-button size="mini" @click="yt.isShowEditDialog = false">{{ $t('quxiao') }}</el-button>
          <el-button size="mini" @click="yt.req('POST', '/web/template/point/unit/create')" type="primary">
            {{ $t('baocun') }}
          </el-button>
        </template>
      </template>
      <!-- 更新表单 -->
      <template v-if="yt.editObj.action == 'bianji'">
        <el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth">
          <el-form-item :label="$t('suoshumuban')" required>
            <el-input disabled v-model="yt.editObj.template.name"></el-input>
          </el-form-item>
          <el-form-item :label="$t('mubandianbianma')" required>
            <el-input disabled v-model="yt.editObj.point.code"></el-input>
          </el-form-item>
          <el-form-item :label="$t('danwei')" required>
            <el-input v-model="yt.editObj.unit"></el-input>
          </el-form-item>
          <el-form-item :label="$t('jisuangongshi')" required>
            <el-input v-model="yt.editObj.formula"></el-input>
          </el-form-item>
          <el-form-item :label="$t('zhuanghuanbiaoshi')" required>
            <yi_dictionary_select :max="1" :type="'ADMIN_UNIT_CONVERSION_TYPE'" :ids.sync="yt.editObj.tag">
            </yi_dictionary_select>
          </el-form-item>
          <el-form-item :label="$t('beizhu')">
            <el-input v-model="yt.editObj.remark"></el-input>
          </el-form-item>

        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button size="mini" @click="yt.isShowEditDialog = false">{{ $t('quxiao') }}</el-button>
          <el-button size="mini" @click="yt.req('POST', '/web/template/point/unit/update')" type="primary">
            {{ $t('baocun') }}
          </el-button>

        </span>
      </template>
    </el-dialog>
    <!-- 导入excel -->
    <importExcel :show.sync="importExcelShow" />
  </div>
</template>
<script type="text/javascript">
import importExcel from '@@/pages/admin/data_template/protocol/point_unit/import_excel';

export default {
  name: 'admin_data_template_protocol_point_unit_list',
  components: {
    importExcel
  },
  data() {
    return {
      list: [],
      templateList: [],
      show: false,
      importExcelShow: false,
      columns: [{
        label: 'suoshumuban',
        prop: 'template.name'
      }, {
        label: 'mubandianbianma',
        prop: 'point.code'
      }, {
        label: 'danwei',
        prop: 'unit'
      }, {
        label: 'jisuangongshi',
        prop: 'formula'
      },
      {
					label: 'zhuanghuanbiaoshi',
					prop: 'tag',
					type: 'dictionary',
					key: 'ADMIN_UNIT_CONVERSION_TYPE',
				},
      {
        label: 'beizhu',
        prop: 'remark'
      }, {
        label: 'caozuo',
        type: 'slot',
        width: 180,
        fixed: 'right'
      }]
    };
  },
  created() {
    setTimeout(() => {
      this.yt.conditions = {
        orderBy: 'createTime desc',
      }
      this.getSelectItemList();
      this.yt.get(1);
    }, 300)
  },

  methods: {
    // 获取字典类型
    async getSelectItemList() {
      let templateResponse = await this.http.get('/web/template/page', {
        params: {
          pageNum: 1,
          pageSize: 100
        }
      })
      this.templateList = templateResponse.data.rows
    }
  }
};
</script>
